import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

const variants = {
  primary:
    "text-[hsl(var(--navy-deep))] bg-gradient-cta hover:shadow-glow",
  outline:
    "text-white border border-white/25 hover:border-[hsl(var(--cyan))]/70 hover:text-[hsl(var(--cyan))] bg-white/0 hover:bg-white/[0.04]",
  ghost:
    "text-foreground hover:text-primary",
  solidDark:
    "text-white bg-[hsl(var(--navy))] hover:bg-[hsl(var(--navy-2))]",
};

const sizes = {
  md: "px-5 py-2.5 text-sm",
  lg: "px-7 py-3.5 text-sm",
};

export const CTAButton = ({
  to,
  href,
  external = false,
  variant = "primary",
  size = "md",
  children,
  icon = true,
  className = "",
  ...rest
}) => {
  const base = cn(
    "group inline-flex items-center gap-2 rounded-full font-semibold transition-all duration-300 focus-ring shine",
    sizes[size],
    variants[variant],
    className
  );

  const content = (
    <>
      <span>{children}</span>
      {icon && (
        <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5" />
      )}
    </>
  );

  if (external && href) {
    return (
      <a href={href} target="_blank" rel="noreferrer" className={base} {...rest}>
        {content}
      </a>
    );
  }
  if (to) {
    return (
      <Link to={to} className={base} {...rest}>
        {content}
      </Link>
    );
  }
  return (
    <button type="button" className={base} {...rest}>
      {content}
    </button>
  );
};

export default CTAButton;
